import { createFileRoute } from "@tanstack/react-router";

import { AuthShell } from "@features/auth/AuthShell";
import { requireSignedOut } from "@features/auth/route-guards";

export const Route = createFileRoute("/login")({
  beforeLoad: requireSignedOut,
  component: LoginPage,
});

function LoginPage() {
  return (
    <AuthShell.Root mode="login">
      <AuthShell.Wordmark />
      <AuthShell.Tagline />
      <AuthShell.SocialRow providers={["google", "twitter", "discord", "github"]} />
      <AuthShell.Divider />
      <AuthShell.EmailForm />
      <AuthShell.Footer />
    </AuthShell.Root>
  );
}
